import { digitsOnly, result } from '../shared';

export const key = 'us_ssn';

export const meta = {
  label: 'US Social Security Number',
  sensitive: true,
  allowed_contact_types: ['string', 'secret'],
  allowed_form_types: ['Text'],
};

export function validate(value) {
  const digits = digitsOnly(value);
  if (!digits) {
    return result(false, '', 'US Social Security number is required');
  }
  if (digits.length !== 9) {
    return result(
      false,
      digits,
      `US Social Security number must be exactly 9 digits (got ${digits.length})`
    );
  }

  const area = parseInt(digits.slice(0, 3), 10);
  const group = digits.slice(3, 5);
  const serial = digits.slice(5);

  if (area === 0 || area === 666 || area >= 900) {
    return result(
      false,
      digits,
      'US Social Security number has an invalid area number'
    );
  }
  if (group === '00') {
    return result(
      false,
      digits,
      'US Social Security number has an invalid group number'
    );
  }
  if (serial === '0000') {
    return result(
      false,
      digits,
      'US Social Security number has an invalid serial number'
    );
  }

  return result(true, digits);
}

export function normalize(value) {
  const res = validate(value);
  return res.valid ? res.value : digitsOnly(value);
}

export function display(value, { context } = {}) {
  const digits = digitsOnly(value);
  if (!digits) return '';

  if (context === 'list') {
    return `***-**-${digits.slice(5)}`;
  }

  if (context === 'revealed' || context === 'edit' || context === 'detail') {
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  }

  return '••••••••';
}

export function getInputProps() {
  return {
    mask: '###-##-####',
    maxlength: 11,
  };
}
